// extracted by mini-css-extract-plugin
export var backdropBlur = "_ll-0";
export var contentCard = "_ll-5";
export var frame = "_ll-2";
export var image = "_ll-4";
export var imagePane = "_ll-3";
export var modal = "_ll-1";